import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import useScrollReveal from "../hooks/useScrollReveal";
import { writeups, portraits } from "../mock";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { FileText, Calendar, ArrowRight } from "lucide-react";
import TextToSpeech from "../components/TextToSpeech";

export default function WriteUp() {
  useScrollReveal();
  const [active, setActive] = useState(null);

  return (
    <div>
      <PageHeader
        eyebrow="Articles & Columns"
        title="Write Up"
        subtitle="Selected essays and newspaper columns on India's foreign policy, the United Nations, nuclear diplomacy and the changing world order."
        image={portraits.smile}
      />

      <section className="py-20 bg-[#faf8f4]">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-6">
          {writeups.map((w, i) => (
            <article
              key={w.id}
              className="group bg-white rounded-lg border border-[#eae4d8] p-7 hover:shadow-lg hover:border-[#b8935a] hover:-translate-y-1 transition-all duration-300 reveal flex flex-col"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-center gap-3 text-[#b8935a]">
                <FileText size={18} />
                <span className="text-xs font-semibold uppercase tracking-wider">
                  {w.source}
                </span>
              </div>
              <h3 className="font-serif text-xl font-semibold text-[#1a2b4a] mt-3 leading-snug">
                {w.title}
              </h3>
              <p className="inline-flex items-center gap-1.5 text-xs text-[#8a8f9c] mt-2">
                <Calendar size={13} /> {w.date}
              </p>
              <p className="mt-4 text-sm text-[#5a6070] leading-relaxed line-clamp-4">
                {w.excerpt}
              </p>
              <div className="mt-auto pt-5 flex flex-wrap items-center gap-3">
                <button
                  onClick={() => setActive(w)}
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#b8935a] hover:gap-3 transition-all"
                >
                  Continue reading <ArrowRight size={15} />
                </button>
                <TextToSpeech text={`${w.title}. ${w.excerpt}`} compact />
              </div>
            </article>
          ))}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl bg-[#faf8f4] border-[#eae4d8]">
          {active && (
            <>
              <DialogHeader>
                <p className="text-xs font-semibold text-[#b8935a] uppercase tracking-wider">
                  {active.source} · {active.date}
                </p>
                <DialogTitle className="font-serif text-2xl md:text-3xl text-[#1a2b4a] leading-snug text-left">
                  {active.title}
                </DialogTitle>
              </DialogHeader>
              <div className="mt-3">
                <TextToSpeech text={`${active.title}. ${active.excerpt}`} />
              </div>
              <p className="mt-4 text-[#3a4155] leading-[1.9] text-[15px]">
                {active.excerpt}
              </p>
              <p className="mt-4 text-sm text-[#8a8f9c]">
                {active.source && active.source !== "Column"
                  ? `Published in ${active.source}${active.date ? `, ${active.date}` : ""}.`
                  : "A commentary by Ambassador T.P. Sreenivasan."}
              </p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
